// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Reports-emptyMessage__GG604{display:flex;flex:1;flex-direction:column;margin-top:10dvh;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emptyMessage": "Reports-emptyMessage__GG604"
};
export default ___CSS_LOADER_EXPORT___;
